<template>
  <!-- New Menu by Asif -->
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="nav-bar">
          <div class="logo-part">
            <!-- <div class="toggle-btn">
              <a
                href="#"
                class="nav-link"
                role="button"
                @click="showNav = !showNav"
              >
                <i class="bi bi-list"></i>
              </a>
            </div> -->
            <div class="logo">
              <router-link
                to="/dashboard"
                style="border: none; padding: 0 !important; float: left"
              >
                <img
                  src="../../assets/shuttle_partner_logo_purple.png"
                  alt="shuttle-logo"
                  height="74"
                  class="align-text-top logo"
                />
              </router-link>
            </div>
            <div class="sidebar-toggle-btn">
              <i class="bi bi-list" @click="this.$emit('toggleSidebar')"></i>
            </div>
          </div>
          <div class="nav-user">
            <!-- <ul>
              <li class="menu-item">
                <router-link
                  to="/trip-request/trip/create"
                  :class="{
                    'nav-link': true,
                    'router-link-active': menus['trip-create']
                  }"
                  >Create Trip Request
                </router-link>
              </li>
            </ul> -->
            <ul>
              <li class="menu-item">
                <router-link
                  class="nav-link dropdown-toggle"
                  to="/"
                  role="button"
                  id="navbarDropdown"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <img
                    src="https://www.gravatar.com/avatar/205e460b479e2e5b48aec07710c08d50?s=200"
                    class="rounded-circle"
                    width="40"
                    height="40"
                    alt="Avatar"
                  />
                  <span
                    style="padding: 0 8px; font-size: 14px; font-weight: 500"
                    >{{ userName }}</span
                  >
                  <i class="bi bi-chevron-down" style="font-size: 13px"></i>
                </router-link>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <a class="dropdown-item" @click="logOut">Logout</a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { activeMenus } from '../../store/navActiveMenu';
export default {
  name: 'TheHeader',
  data() {
    return {
      showNav: true,
      menus: activeMenus.menus,
      userName: localStorage.getItem('userName')
    };
  },

  methods: {
    logOut() {
      localStorage.removeItem('token');
      localStorage.removeItem('userCode');
      localStorage.removeItem('role_name');
      localStorage.removeItem('userPermission');
      localStorage.removeItem('userName');
      localStorage.removeItem('modality');
      localStorage.removeItem('serviceType');
      this.$router.push({ name: 'login' });
    }
  }
};
</script>

<style scoped>
/* Style by Asif Start */
.nav-bar {
  overflow: hidden;
  /* margin: 0 40px; */
}
.logo-part {
  width: 250px;
  float: left;
  height: 80px;
  display: table;
}
.logo {
  display: table-cell;
  vertical-align: middle;
}
.navbar-menu {
  width: 62%;
  float: left;
  height: 80px;
  display: table;
}
.navbar-menu ul {
  margin: 0;
  overflow: hidden;
  padding: 0;
  display: table-cell;
  vertical-align: middle;
}
.menu-item {
  float: left;
  list-style: none;
}
.menu-item a {
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  color: #000;
}
.nav-user {
  float: right;
  display: table;
  height: 80px;
}
.nav-user ul {
  display: table-cell;
  vertical-align: middle;
  padding: 0;
}
.dropdown-item {
  color: #000 !important;
  cursor: pointer;
}
.dropdown-toggle {
  float: right;
}
.dropdown-toggle::after {
  display: none !important;
}
a.nav-link {
  padding: 0 !important;
}
.toggle-btn {
  display: none;
  vertical-align: middle;
  width: 10px;
}
.sidebar-toggle-btn {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}
.sidebar-toggle-btn i:hover {
  transition: 0.5s;
  color: #a95eea;
}
.toggle-btn i,
.sidebar-toggle-btn i {
  cursor: pointer;
  font-size: 30px;
  color: #652f8f;
}
/* Style by Asif End */

nav {
  margin: 0 25px;
}

.navbar {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}

.navbar .logo {
  margin-right: 1rem;
}

.navbar ul li a {
  color: #fff;
}

.navbar-brand {
  margin-right: 8rem;
  border: none;
}

.nav-item {
  margin-right: 2rem;
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
}

a.nav-link {
  font-size: 12px;
  padding: 6px 17px;
}
a.nav-link:hover {
  color: #652f8f;
}

.dropdown {
  margin-right: 1rem;
}

.right-menu {
  text-align: left;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: -0.5rem;
}

.router-link-active {
  border: 1px solid #fff;
  padding: 5px 16px !important;
  border-radius: 5px;
}

.router-link-exact-active {
  border: 1px solid #fff;
  padding: 5px 16px !important;
  border-radius: 5px;
}

button {
  padding: 0.5rem;
  border-radius: 0.25rem;
}

button a {
  color: #fff !important;
}

button a:hover,
button a:active {
  color: #fff;
}

.dropdown-menu {
  background-color: #ffffff;
  width: auto;
  margin-left: -45px !important;
}

.dropdown-menu li a {
  color: #1d1c1c !important;
}

.dropdown-menu li a:hover {
  background: none;
}

a .actice {
  color: #fff !important;
}

.active:active {
  color: #fff !important;
}
</style>
